module.exports = __webpack_public_path__ + "img/money.a26e75f9.svg";